import { PlaybooksById } from 'api/conversation/playbooks/types'
import { createAction, createReceiveActionWithOptions } from 'utils/redux'

export const fetchPlaybooksByIds = createAction('FETCH_PLAYBOOKS_BY_IDS')
export const fetchPlaybooksByIdsFailed = createAction(
  'FETCH_PLAYBOOKS_BY_IDS_FAILED'
)
export const receivePlaybooks =
  createReceiveActionWithOptions<PlaybooksById>('playbooks')
export const fetchPlaybooksByOrg = createAction('FETCH_PLAYBOOKS_BY_ORG')
export const fetchPlaybooksByOrgFailed = createAction(
  'FETCH_PLAYBOOKS_BY_ORG_FAILED'
)
